export default "__VITE_ASSET__C2DJw4tJ__"